import { start } from '~/apps/standalone/main'

start('#app')
